import { createTheme } from '@mui/material/styles';
import { themePalette, TypographyVariant } from 'theme';

const baseFormMuiTheme = createTheme({
  palette: themePalette,
  typography: TypographyVariant,
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          borderColor: 'transparent',
        },
      },
    },
  },
});

export default baseFormMuiTheme;
